import moment from "moment";

const PurchaseBasicDetails = ({ item }) => {
  const vendorData = [
    {
      label: "Vendor Name",
      value: item?.vendor,
    },
    {
      label: "Issued Date",
      value: moment(item?.createdAt).format("DD MMM YYYY"),
    },
    {
      label: "Expected Date",
      value: moment(item?.expected_date).format("DD MMM YYYY"),
    },
    { label: "Stustus", value: item?.status },
  ];

  return (
    <div className="grid grid-cols-2 gap-4">
      {vendorData.map((item, index) => {
        return (
          <div key={index} className="flex flex-col font-medium">
            <span className="text-gray-600">{item?.label}</span>
            <span className="text-theme font-bold">{item?.value}</span>
          </div>
        );
      })}
    </div>
  );
};
export default PurchaseBasicDetails;
